import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from 'src/app/core/store/store';
import { Course, Module } from 'src/app/shared/models/course.model';
import { User, VisitedCourse } from 'src/app/shared/models/user.model';
import { environment } from 'src/environments/environment';
import { PlayerUtilityService } from '../../../services/player-utility.service';
import * as io from 'socket.io-client';
import * as moment from 'moment';


@Component({
  selector: 'app-qanda',
  templateUrl: './qanda.component.html',
  styleUrls: ['./qanda.component.css']
})
export class QandaComponent implements OnInit {
  modules: Module[] = [];
  submitQuestionEnable = true;
  replyButtonEnable = true;
  // likeEnable=true;
  lastVisitedContentId: string;
  socket: SocketIOClient.Socket;
  toDoList;
  userSubscription;
  isEditPost = false;
  isEditComment = false;
  updatedPostMessage;
  updatedPostComment;
  currentId: string;
  completedContents: string[];
  currentCourse: VisitedCourse;
  message: any;
  messages: string[] = [];
  userId;
  user;
  isDeleted;
  notificationMsg;
  commentText;
  moduleSetting = {};
  _moduleOverview = {
    show: false,
    moduleNumber: 0,
    moduleName: ''
  };
  courseSubscription;
  course:Course
  @Output() openModuleOverview = new EventEmitter<any>();
  @Output() hideWalkthrough = new EventEmitter();
  @Output() hideCourseProgress = new EventEmitter();
  @Output() totalMessage = new EventEmitter();
  @Input() courseId: string;
  @Input() set moduleOverview(value) { this._moduleOverview = value; }
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() sideBarClicked: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  constructor(private http: HttpClient,private store: Store, private playerUtilityService :PlayerUtilityService,private router: Router) {
    this.socket = io(environment.basePath, { 'transports': ['websocket', 'polling'] });
  }

  ngOnInit() {
      this.getAllPostQuestionByCourse(0);
      this.socket.on('newMessageAdded' , () => {
        this.getAllPostQuestionByCourse(0);
      });
      this.socket.on('updateMessages' , (data) => {
        this.getAllPostQuestionByCourse(data);
      });
      this.userSubscription = this.store.select<User>(`user`).subscribe(user => {
          this.userId=user._id;
          this.user = user;
      });
      this.courseSubscription = this.store.select<Course>(`course`).subscribe(course => {
        if (course) {
          this.course = course;
          console.log(this.course);
        }
      });
  }

  showComments(msg,i){
    this.messages[i]['showComments'] = !this.messages[i]['showComments'];
  }

  cancelMsg(msg,i){
    this.messages[i]['isEditPost'] = false;
  }

  hideNotification(){
    this.isDeleted = false;
  }

  cancelComment(comment,msg,j){
    comment['isEditComment'] = false;
  }

  addPost(){
    this.submitQuestionEnable= true;
    this.playerUtilityService.submitPostQuestion({ question : this.message , courseID : this.courseId ,createdBy : this.userId }).subscribe(res => {
      this.message = "";
    });
  }

  addLikePost(msg,i , type) {
    let likeObj = {
      userId : this.userId,
      postId : msg._id,
      commentId : null,
      isPost : 0,
      createdBy : this.userId,
    }
    this.playerUtilityService.likePost(likeObj).subscribe();
  }

  getTimeStamp(date){
    return moment(date).fromNow();
  }

  addLikeComment(comment , msg , i){
    let likeObj = {
      userId : this.userId,
      postId : msg._id,
      commentId : comment._id,
      isPost : 1,
      createdBy : this.userId,
      isLike: true,
    }
    this.playerUtilityService.likePost(likeObj).subscribe();
  }

  editPost(msg,i){
    msg.isEditPost = true;
    this.updatedPostMessage = msg.question;
  }

  editComment(comment,msg , i){
    comment.isEditComment = true;
    this.updatedPostComment = comment.description;
  }

  addPostComment(comment , msg , i) {
    this.playerUtilityService.updatePostComment({description : this.updatedPostComment , _id : comment._id , isDeleted : false}).subscribe(data => {
      this.updatedPostComment = "";
      comment.isEditComment = false;
    })
  }

  deleteComment(comment,msg, i ) {
    this.playerUtilityService.deleteComment({ _id : comment._id, isDeleted : true, postId : msg._id }).subscribe(res => {
      this.notificationMsg = 'Your Comment has been deleted !'
      this.isDeleted = true;
      setTimeout(() => {
        this.isDeleted = false;
      }, 5000);
    });
  }


  addPostMessage(msg,i){
    console.log(msg);
    this.playerUtilityService.updatePostQuestion({ question : this.updatedPostMessage, _id : msg._id , isDeleted : false }).subscribe(data => {
      this.isEditPost = false;
      this.updatedPostMessage = "";
    });
  }

  deletePost(msg,i){
    this.playerUtilityService.updatePostQuestion({ question : msg.question, isDeleted : true, _id : msg._id }).subscribe(res => {
      this.notificationMsg = 'Your Post has been deleted !'
      this.isDeleted = true;
      setTimeout(() => {
        this.isDeleted = false;
      }, 5000);
    });
  }

  flagPost(msg,i){
    let flagObj = {
      userId : this.userId,
      name : this.user.name,
      flagedPost : msg.question,
      postUrl: window.location.origin+this.router.url,
      postId : msg._id,
      commentId : null,
      isPost : 0,
      createdBy : this.userId,
      organization: this.course['organization'],
      templateName: this.course.templateName
    }
    this.playerUtilityService.flagPost(flagObj).subscribe(res => {
      this.notificationMsg = 'This post has been reported !'
      this.isDeleted = true;
      setTimeout(() => {
        this.isDeleted = false;
      }, 5000);
    });
  }

  flagComment(comment,msg,i){
    let flagObj = {
      userId : this.userId,
      postId : msg._id,
      commentId : comment._id,
      name : this.user.name,
      isPost : 1,
      createdBy : this.userId,
      flagedPost : comment.description,
      postUrl: window.location.origin+this.router.url,
    }
    this.playerUtilityService.flagPost(flagObj).subscribe(res => {
      this.notificationMsg = 'This comment has been reported !'
      this.isDeleted = true;
      setTimeout(() => {
        this.isDeleted = false;
      }, 5000);
    });
  }

  addReply(msg) {
    if(!this.commentText) {
      return;
    }
    this.replyButtonEnable = true;
    let commentObj = {
      userId : this.userId,
      postId : msg._id,
      description: this.commentText,
      commentId : null,
      isPost : 0,
      createdBy : this.userId
    };
    this.playerUtilityService.commentPost(commentObj).subscribe(data => {
      this.commentText = "";
    });
  }

  unLikePost(msg,i){
    let likeObj = {
      userId : this.userId,
      postId : msg._id,
      commentId : null,
      isPost : 0,
      createdBy : this.userId
    }
    this.playerUtilityService.unlikePost(likeObj).subscribe();
  }



  getAllPostQuestionByCourse(flag){
    this.playerUtilityService.getPostQuestions({ courseID : this.courseId}).subscribe(data => {
      this.messages = data;
      this.submitQuestionEnable = false;
      this.replyButtonEnable = false;
      // this.likeEnable = false;
      this.totalMessage.emit(this.messages.length);
      this.messages.forEach((item, postIndex) => {
        if(flag && flag.postId && item["_id"] === flag.postId){
          item["showComments"] = true;
        } else{
          item["showComments"] = false;
        }
        item["isEditPost"] = false;
        item["isEditComment"] = false;        
        this.addFlagInPosts(item , postIndex);
        this.addLikeInPosts(item , postIndex);
        this.addEditPermission(item,postIndex);
        if(item["comments"].length > 0){
          item["comments"].forEach((comment,commentIndex) => {
            this.addLikeInComments(comment, postIndex ,commentIndex);
            this.addEditPermissionComment(comment , postIndex , commentIndex);
            this.addFlagInComments(comment , postIndex ,commentIndex);
          });
        }
      });
      console.log(this.messages);
    })
  }

  


  addEditPermissionComment(item, i, j) {
    console.log(item);
    if (item.users.length > 0 &&  item.users[0]._id === this.userId) {
      this.messages[i]["comments"][j]["isAuthor"] = true;
    } else {
      this.messages[i]["comments"][j]["isAuthor"] = false;
    }
  }

  addEditPermission(item , i){
    if (item.users[0]._id === this.userId) {
        this.messages[i]["isAuthor"] = true;
    } else {
      this.messages[i]["isAuthor"] = false;
    }
  }

  addFlagInComments(item, i, j) {
    if (item["flags"].length > 0) {
      if (item["flags"].find(o => o.userId === this.userId))
        this.messages[i]["comments"][j]["isFlag"] = true;
      else
        this.messages[i]["comments"][j]["isFlag"] = false;
    } else {
      this.messages[i]["comments"][j]["isFlag"] = false;
    }
  }

  addLikeInComments(item, i, j) {
    if (item["likes"].length > 0) {
      if (item["likes"].find(o => o.userId === this.userId))
        this.messages[i]["comments"][j]["isLike"] = true;
      else
        this.messages[i]["comments"][j]["isLike"] = false;
    } else {
      this.messages[i]["comments"][j]["isLike"] = false;
    }
  }

  addLikeInPosts(item , i){
    if(item["likes"].length > 0) {
      if(item["likes"].find(o => o.userId === this.userId ))
      this.messages[i]["isLike"] = true;
      else
      this.messages[i]["isLike"] = false;
    }else {
      this.messages[i]["isLike"] = false;
    }
  }

  addFlagInPosts(item , i){
    if(item["flags"].length > 0) {
      console.log(item["flags"].length);
      if(item["flags"].find(o => o.userId === this.userId ))
      this.messages[i]["isFlag"] = true;
      else
      this.messages[i]["isFlag"] = false;
    }else {
      this.messages[i]["isFlag"] = false;
    }
  }

  onClose() {
    this.close.emit(true);
  }


}
